import { sanitizeHtmlContent, strictSanitizeOptions } from './sanitizeHtml';
import sanitizeHtml from 'sanitize-html';

/**
 * Sanitizes a string value by removing HTML tags and dangerous content
 * This should be used for all user input strings
 * 
 * @param value - The string to sanitize
 * @param options - Custom sanitization options (defaults to strict)
 * @returns Sanitized string or null if input was null/undefined
 */
export const sanitizeString = (
  value: unknown,
  options: sanitizeHtml.IOptions = strictSanitizeOptions
): string | null => {
  if (value == null) {
    return null;
  }

  if (typeof value === 'string') {
    return sanitizeHtmlContent(value, options);
  }

  if (value.toString) {
    return sanitizeHtmlContent(value.toString(), options);
  }

  return sanitizeHtmlContent(`${value}`, options);
};

